function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { makeDraggable } from './draggable.js';
import EventEmitter from './event-emitter.js';

var Renderer = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Renderer, _EventEmitter);

  var _super = _createSuper(Renderer);

  function Renderer(options, audioElement) {
    var _this;

    _classCallCheck(this, Renderer);

    _this = _super.call(this);
    _this.timeouts = [];
    _this.isScrollable = false;
    _this.audioData = null;
    _this.resizeObserver = null;
    _this.lastContainerWidth = 0;
    _this.isDragging = false;
    _this.options = options;

    var parent = _this.parentFromOptionsContainer(options.container);

    _this.parent = parent;

    var _this$initHtml = _this.initHtml(),
        _this$initHtml2 = _slicedToArray(_this$initHtml, 2),
        div = _this$initHtml2[0],
        shadow = _this$initHtml2[1];

    parent.appendChild(div);
    _this.container = div;
    _this.scrollContainer = shadow.querySelector('.scroll');
    _this.wrapper = shadow.querySelector('.wrapper');
    _this.canvasWrapper = shadow.querySelector('.canvases');
    _this.progressWrapper = shadow.querySelector('.progress');
    _this.cursor = shadow.querySelector('.cursor');

    if (audioElement) {
      shadow.appendChild(audioElement);
    }

    _this.initEvents();

    return _this;
  }

  _createClass(Renderer, [{
    key: "parentFromOptionsContainer",
    value: function parentFromOptionsContainer(container) {
      var parent;

      if (typeof container === 'string') {
        parent = document.querySelector(container);
      } else if (container instanceof HTMLElement) {
        parent = container;
      }

      if (!parent) {
        throw new Error('Container not found');
      }

      return parent;
    }
  }, {
    key: "initEvents",
    value: function initEvents() {
      var _this2 = this;

      var getClickPosition = function getClickPosition(e) {
        var rect = _this2.wrapper.getBoundingClientRect();

        var x = e.clientX - rect.left;
        var y = e.clientX - rect.left;
        var relativeX = x / rect.width;
        var relativeY = y / rect.height;
        return [relativeX, relativeY];
      }; // Add a click listener


      this.wrapper.addEventListener('click', function (e) {
        var _getClickPosition = getClickPosition(e),
            _getClickPosition2 = _slicedToArray(_getClickPosition, 2),
            x = _getClickPosition2[0],
            y = _getClickPosition2[1];

        _this2.emit('click', x, y);
      }); // Add a double click listener

      this.wrapper.addEventListener('dblclick', function (e) {
        var _getClickPosition3 = getClickPosition(e),
            _getClickPosition4 = _slicedToArray(_getClickPosition3, 2),
            x = _getClickPosition4[0],
            y = _getClickPosition4[1];

        _this2.emit('dblclick', x, y);
      }); // Drag

      if (this.options.dragToSeek) {
        this.initDrag();
      } // Add a scroll listener


      this.scrollContainer.addEventListener('scroll', function () {
        var _this2$scrollContaine = _this2.scrollContainer,
            scrollLeft = _this2$scrollContaine.scrollLeft,
            scrollWidth = _this2$scrollContaine.scrollWidth,
            clientWidth = _this2$scrollContaine.clientWidth;
        var startX = scrollLeft / scrollWidth;
        var endX = (scrollLeft + clientWidth) / scrollWidth;

        _this2.emit('scroll', startX, endX);
      }); // Re-render the waveform on container resize

      var delay = this.createDelay(100);
      this.resizeObserver = new ResizeObserver(function () {
        delay().then(function () {
          return _this2.onContainerResize();
        }).catch(function () {
          return undefined;
        });
      });
      this.resizeObserver.observe(this.scrollContainer);
    }
  }, {
    key: "onContainerResize",
    value: function onContainerResize() {
      var width = this.parent.clientWidth;
      if (width === this.lastContainerWidth && this.options.height !== 'auto') return;
      this.lastContainerWidth = width;
      this.reRender();
    }
  }, {
    key: "initDrag",
    value: function initDrag() {
      var _this3 = this;

      makeDraggable(this.wrapper, // On drag
      function (_, __, x) {
        _this3.emit('drag', Math.max(0, Math.min(1, x / _this3.wrapper.getBoundingClientRect().width)));
      }, // On start drag
      function () {
        return _this3.isDragging = true;
      }, // On end drag
      function () {
        return _this3.isDragging = false;
      });
    }
  }, {
    key: "getHeight",
    value: function getHeight(optionsHeight) {
      var defaultHeight = 128;
      if (optionsHeight == null) return defaultHeight;
      if (!isNaN(Number(optionsHeight))) return Number(optionsHeight);
      if (optionsHeight === 'auto') return this.parent.clientHeight || defaultHeight;
      return defaultHeight;
    }
  }, {
    key: "initHtml",
    value: function initHtml() {
      var div = document.createElement('div');
      var shadow = div.attachShadow({
        mode: 'open'
      });
      shadow.innerHTML = "\n      <style>\n        :host {\n          user-select: none;\n          min-width: 1px;\n        }\n        :host audio {\n          display: block;\n          width: 100%;\n        }\n        :host .scroll {\n          overflow-x: auto;\n          overflow-y: hidden;\n          width: 100%;\n          position: relative;\n        }\n        :host .noScrollbar {\n          scrollbar-color: transparent;\n          scrollbar-width: none;\n        }\n        :host .noScrollbar::-webkit-scrollbar {\n          display: none;\n          -webkit-appearance: none;\n        }\n        :host .wrapper {\n          position: relative;\n          overflow: visible;\n          z-index: 2;\n        }\n        :host .canvases {\n          min-height: ".concat(this.getHeight(this.options.height), "px;\n        }\n        :host .canvases > div {\n          position: relative;\n        }\n        :host canvas {\n          display: block;\n          position: absolute;\n          top: 0;\n          image-rendering: pixelated;\n        }\n        :host .progress {\n          pointer-events: none;\n          position: absolute;\n          z-index: 2;\n          top: 0;\n          left: 0;\n          width: 0;\n          height: 100%;\n          overflow: hidden;\n        }\n        :host .progress > div {\n          position: relative;\n        }\n        :host .cursor {\n          pointer-events: none;\n          position: absolute;\n          z-index: 5;\n          top: 0;\n          left: 0;\n          height: 100%;\n          border-radius: 2px;\n        }\n      </style>\n\n      <div class=\"scroll\" part=\"scroll\">\n        <div class=\"wrapper\" part=\"wrapper\">\n          <div class=\"canvases\"></div>\n          <div class=\"progress\" part=\"progress\"></div>\n          <div class=\"cursor\" part=\"cursor\"></div>\n        </div>\n      </div>\n    ");
      return [div, shadow];
    }
    /** Wavesurfer itself calls this method. Do not call it manually. */

  }, {
    key: "setOptions",
    value: function setOptions(options) {
      if (this.options.container !== options.container) {
        var newParent = this.parentFromOptionsContainer(options.container);
        newParent.appendChild(this.container);
        this.parent = newParent;
      }

      if (options.dragToSeek && !this.options.dragToSeek) {
        this.initDrag();
      }

      this.options = options; // Re-render the waveform

      this.reRender();
    }
  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.wrapper;
    }
  }, {
    key: "getScroll",
    value: function getScroll() {
      return this.scrollContainer.scrollLeft;
    }
  }, {
    key: "setScroll",
    value: function setScroll(pixels) {
      this.scrollContainer.scrollLeft = pixels;
    }
  }, {
    key: "setScrollPercentage",
    value: function setScrollPercentage(percent) {
      var scrollWidth = this.scrollContainer.scrollWidth;
      var scrollStart = scrollWidth * percent;
      this.setScroll(scrollStart);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _a;

      this.container.remove();
      (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
  }, {
    key: "createDelay",
    value: function createDelay() {
      var delayMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      var timeout;
      var reject;

      var onClear = function onClear() {
        if (timeout) clearTimeout(timeout);
        if (reject) reject();
      };

      this.timeouts.push(onClear);
      return function () {
        return new Promise(function (resolveFn, rejectFn) {
          onClear();
          reject = rejectFn;
          timeout = setTimeout(function () {
            timeout = undefined;
            reject = undefined;
            resolveFn();
          }, delayMs);
        });
      };
    } // Convert array of color values to linear gradient

  }, {
    key: "convertColorValues",
    value: function convertColorValues(color) {
      if (!Array.isArray(color)) return color || '';
      if (color.length < 2) return color[0] || '';
      var canvasElement = document.createElement('canvas');
      var ctx = canvasElement.getContext('2d');
      var gradientHeight = canvasElement.height * (window.devicePixelRatio || 1);
      var gradient = ctx.createLinearGradient(0, 0, 0, gradientHeight);
      var colorStopPercentage = 1 / (color.length - 1);
      color.forEach(function (color, index) {
        var offset = index * colorStopPercentage;
        gradient.addColorStop(offset, color);
      });
      return gradient;
    }
  }, {
    key: "renderBarWaveform",
    value: function renderBarWaveform(channelData, options, ctx, vScale) {
      var topChannel = channelData[0];
      var bottomChannel = channelData[1] || channelData[0];
      var length = topChannel.length;
      var _ctx$canvas = ctx.canvas,
          width = _ctx$canvas.width,
          height = _ctx$canvas.height;
      var halfHeight = height / 2;
      var pixelRatio = window.devicePixelRatio || 1;
      var barWidth = options.barWidth ? options.barWidth * pixelRatio : 1;
      var barGap = options.barGap ? options.barGap * pixelRatio : options.barWidth ? barWidth / 2 : 0;
      var barRadius = options.barRadius || 0;
      var barIndexScale = width / (barWidth + barGap) / length;
      var rectFn = barRadius && 'roundRect' in ctx ? 'roundRect' : 'rect';
      ctx.beginPath();
      var prevX = 0;
      var maxTop = 0;
      var maxBottom = 0;

      for (var i = 0; i <= length; i++) {
        var x = Math.round(i * barIndexScale);

        if (x > prevX) {
          var topBarHeight = Math.round(maxTop * halfHeight * vScale);
          var bottomBarHeight = Math.round(maxBottom * halfHeight * vScale);
          var barHeight = topBarHeight + bottomBarHeight || 1; // Vertical alignment

          var y = halfHeight - topBarHeight;

          if (options.barAlign === 'top') {
            y = 0;
          } else if (options.barAlign === 'bottom') {
            y = height - barHeight;
          }

          ctx[rectFn](prevX * (barWidth + barGap), y, barWidth, barHeight, barRadius);
          prevX = x;
          maxTop = 0;
          maxBottom = 0;
        }

        var magnitudeTop = Math.abs(topChannel[i] || 0);
        var magnitudeBottom = Math.abs(bottomChannel[i] || 0);
        if (magnitudeTop > maxTop) maxTop = magnitudeTop;
        if (magnitudeBottom > maxBottom) maxBottom = magnitudeBottom;
      }

      ctx.fill();
      ctx.closePath();
    }
  }, {
    key: "renderLineWaveform",
    value: function renderLineWaveform(channelData, _options, ctx, vScale) {
      var drawChannel = function drawChannel(index) {
        var channel = channelData[index] || channelData[0];
        var length = channel.length;
        var height = ctx.canvas.height;
        var halfHeight = height / 2;
        var hScale = ctx.canvas.width / length;
        ctx.moveTo(0, halfHeight);
        var prevX = 0;
        var max = 0;

        for (var i = 0; i <= length; i++) {
          var x = Math.round(i * hScale);

          if (x > prevX) {
            var h = Math.round(max * halfHeight * vScale) || 1;
            var y = halfHeight + h * (index === 0 ? -1 : 1);
            ctx.lineTo(prevX, y);
            prevX = x;
            max = 0;
          }

          var value = Math.abs(channel[i] || 0);
          if (value > max) max = value;
        }

        ctx.lineTo(prevX, halfHeight);
      };

      ctx.beginPath();
      drawChannel(0);
      drawChannel(1);
      ctx.fill();
      ctx.closePath();
    }
  }, {
    key: "renderWaveform",
    value: function renderWaveform(channelData, options, ctx) {
      ctx.fillStyle = this.convertColorValues(options.waveColor); // Custom rendering function

      if (options.renderFunction) {
        options.renderFunction(channelData, ctx);
        return;
      } // Vertical scaling


      var vScale = options.barHeight || 1;

      if (options.normalize) {
        var max = Array.from(channelData[0]).reduce(function (max, value) {
          return Math.max(max, Math.abs(value));
        }, 0);
        vScale = max ? 1 / max : 1;
      } // Render waveform as bars


      if (options.barWidth || options.barGap || options.barAlign) {
        this.renderBarWaveform(channelData, options, ctx, vScale);
        return;
      } // Render waveform as a polyline


      this.renderLineWaveform(channelData, options, ctx, vScale);
    }
  }, {
    key: "renderSingleCanvas",
    value: function renderSingleCanvas(channelData, options, width, height, start, end, canvasContainer, progressContainer) {
      var pixelRatio = window.devicePixelRatio || 1;
      var canvas = document.createElement('canvas');
      var length = channelData[0].length;
      canvas.width = Math.round(width * (end - start) / length);
      canvas.height = height * pixelRatio;
      canvas.style.width = "".concat(Math.floor(canvas.width / pixelRatio), "px");
      canvas.style.height = "".concat(height, "px");
      canvas.style.left = "".concat(Math.floor(start * width / pixelRatio / length), "px");
      canvasContainer.appendChild(canvas);
      var ctx = canvas.getContext('2d');
      this.renderWaveform(channelData.map(function (channel) {
        return channel.slice(start, end);
      }), options, ctx); // Draw a progress canvas

      if (canvas.width > 0 && canvas.height > 0) {
        var progressCanvas = canvas.cloneNode();
        var progressCtx = progressCanvas.getContext('2d');
        progressCtx.drawImage(canvas, 0, 0); // Set the composition method to draw only where the waveform is drawn

        progressCtx.globalCompositeOperation = 'source-in';
        progressCtx.fillStyle = this.convertColorValues(options.progressColor); // This rectangle acts as a mask thanks to the composition method

        progressCtx.fillRect(0, 0, canvas.width, canvas.height);
        progressContainer.appendChild(progressCanvas);
      }
    }
  }, {
    key: "renderChannel",
    value: function renderChannel(channelData, options, width) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        var canvasContainer, height, progressContainer, dataLength, draw, _this$scrollContainer, scrollLeft, scrollWidth, clientWidth, scale, viewportWidth, barWidth, barGap, totalBarWidth, start, end, viewportLen;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // A container for canvases
                canvasContainer = document.createElement('div');
                height = this.getHeight(options.height);
                canvasContainer.style.height = "".concat(height, "px");
                this.canvasWrapper.style.minHeight = "".concat(height, "px");
                this.canvasWrapper.appendChild(canvasContainer); // A container for progress canvases

                progressContainer = canvasContainer.cloneNode();
                this.progressWrapper.appendChild(progressContainer);
                dataLength = channelData[0].length; // Draw a portion of the waveform from start peak to end peak

                draw = function draw(start, end) {
                  _this4.renderSingleCanvas(channelData, options, width, height, Math.max(0, start), Math.min(end, dataLength), canvasContainer, progressContainer);
                }; // Draw the entire waveform


                if (this.isScrollable) {
                  _context3.next = 12;
                  break;
                }

                draw(0, dataLength);
                return _context3.abrupt("return");

              case 12:
                // Determine the currently visible part of the waveform
                _this$scrollContainer = this.scrollContainer, scrollLeft = _this$scrollContainer.scrollLeft, scrollWidth = _this$scrollContainer.scrollWidth, clientWidth = _this$scrollContainer.clientWidth;
                scale = dataLength / scrollWidth;
                viewportWidth = Math.min(Renderer.MAX_CANVAS_WIDTH, clientWidth); // Adjust width to avoid gaps between canvases when using bars

                if (options.barWidth || options.barGap) {
                  barWidth = options.barWidth || 0.5;
                  barGap = options.barGap || barWidth / 2;
                  totalBarWidth = barWidth + barGap;

                  if (viewportWidth % totalBarWidth !== 0) {
                    viewportWidth = Math.floor(viewportWidth / totalBarWidth) * totalBarWidth;
                  }
                }

                start = Math.floor(Math.abs(scrollLeft) * scale);
                end = Math.floor(start + viewportWidth * scale);
                viewportLen = end - start;

                if (!(viewportLen <= 0)) {
                  _context3.next = 21;
                  break;
                }

                return _context3.abrupt("return");

              case 21:
                // Draw the visible part of the waveform
                draw(start, end); // Draw the waveform in chunks equal to the size of the viewport, starting from the position of the viewport

                _context3.next = 24;
                return Promise.all([// Draw the chunks to the left of the viewport
                function () {
                  return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var delay, i;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(start === 0)) {
                              _context.next = 2;
                              break;
                            }

                            return _context.abrupt("return");

                          case 2:
                            delay = this.createDelay();
                            i = start;

                          case 4:
                            if (!(i >= 0)) {
                              _context.next = 11;
                              break;
                            }

                            _context.next = 7;
                            return delay();

                          case 7:
                            draw(Math.max(0, i - viewportLen), i);

                          case 8:
                            i -= viewportLen;
                            _context.next = 4;
                            break;

                          case 11:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));
                }(), // Draw the chunks to the right of the viewport
                function () {
                  return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                    var delay, i;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!(end === dataLength)) {
                              _context2.next = 2;
                              break;
                            }

                            return _context2.abrupt("return");

                          case 2:
                            delay = this.createDelay();
                            i = end;

                          case 4:
                            if (!(i < dataLength)) {
                              _context2.next = 11;
                              break;
                            }

                            _context2.next = 7;
                            return delay();

                          case 7:
                            draw(i, Math.min(dataLength, i + viewportLen));

                          case 8:
                            i += viewportLen;
                            _context2.next = 4;
                            break;

                          case 11:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this);
                  }));
                }()]);

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "render",
    value: function render(audioData) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this5 = this;

        var pixelRatio, parentWidth, scrollWidth, useParentWidth, width, channels;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // Clear previous timeouts
                this.timeouts.forEach(function (clear) {
                  return clear();
                });
                this.timeouts = []; // Clear the canvases

                this.canvasWrapper.innerHTML = '';
                this.progressWrapper.innerHTML = ''; // Width

                if (this.options.width != null) {
                  this.scrollContainer.style.width = typeof this.options.width === 'number' ? "".concat(this.options.width, "px") : this.options.width;
                } // Determine the width of the waveform


                pixelRatio = window.devicePixelRatio || 1;
                parentWidth = this.scrollContainer.clientWidth;
                scrollWidth = Math.ceil(audioData.duration * (this.options.minPxPerSec || 0)); // Whether the container should scroll

                this.isScrollable = scrollWidth > parentWidth;
                useParentWidth = this.options.fillParent && !this.isScrollable; // Width of the waveform in pixels

                width = (useParentWidth ? parentWidth : scrollWidth) * pixelRatio; // Set the width of the wrapper

                this.wrapper.style.width = useParentWidth ? '100%' : "".concat(scrollWidth, "px"); // Set additional styles

                this.scrollContainer.style.overflowX = this.isScrollable ? 'auto' : 'hidden';
                this.scrollContainer.classList.toggle('noScrollbar', !!this.options.hideScrollbar);
                this.cursor.style.backgroundColor = "".concat(this.options.cursorColor || this.options.progressColor);
                this.cursor.style.width = "".concat(this.options.cursorWidth, "px");
                this.audioData = audioData;
                this.emit('render'); // Render the waveform

                _context4.prev = 18;

                if (!this.options.splitChannels) {
                  _context4.next = 24;
                  break;
                }

                _context4.next = 22;
                return Promise.all(Array.from({
                  length: audioData.numberOfChannels
                }).map(function (_, i) {
                  var _a;

                  var options = Object.assign(Object.assign({}, _this5.options), (_a = _this5.options.splitChannels) === null || _a === void 0 ? void 0 : _a[i]);
                  return _this5.renderChannel([audioData.getChannelData(i)], options, width);
                }));

              case 22:
                _context4.next = 28;
                break;

              case 24:
                // Render a single waveform for the first two channels (left and right)
                channels = [audioData.getChannelData(0)];
                if (audioData.numberOfChannels > 1) channels.push(audioData.getChannelData(1));
                _context4.next = 28;
                return this.renderChannel(channels, this.options, width);

              case 28:
                _context4.next = 33;
                break;

              case 30:
                _context4.prev = 30;
                _context4.t0 = _context4["catch"](18);
                return _context4.abrupt("return");

              case 33:
                this.emit('rendered');

              case 34:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[18, 30]]);
      }));
    }
  }, {
    key: "reRender",
    value: function reRender() {
      // Return if the waveform has not been rendered yet
      if (!this.audioData) return; // Remember the current cursor position

      var scrollWidth = this.scrollContainer.scrollWidth;

      var _this$progressWrapper = this.progressWrapper.getBoundingClientRect(),
          before = _this$progressWrapper.right; // Re-render the waveform


      this.render(this.audioData); // Adjust the scroll position so that the cursor stays in the same place

      if (this.isScrollable && scrollWidth !== this.scrollContainer.scrollWidth) {
        var _this$progressWrapper2 = this.progressWrapper.getBoundingClientRect(),
            after = _this$progressWrapper2.right;

        var delta = after - before; // to limit compounding floating-point drift
        // we need to round to the half px furthest from 0

        delta *= 2;
        delta = delta < 0 ? Math.floor(delta) : Math.ceil(delta);
        delta /= 2;
        this.scrollContainer.scrollLeft += delta;
      }
    }
  }, {
    key: "zoom",
    value: function zoom(minPxPerSec) {
      this.options.minPxPerSec = minPxPerSec;
      this.reRender();
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(progress) {
      var isPlaying = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$scrollContainer2 = this.scrollContainer,
          scrollLeft = _this$scrollContainer2.scrollLeft,
          scrollWidth = _this$scrollContainer2.scrollWidth,
          clientWidth = _this$scrollContainer2.clientWidth;
      var progressWidth = progress * scrollWidth;
      var startEdge = scrollLeft;
      var endEdge = scrollLeft + clientWidth;
      var middle = clientWidth / 2;

      if (this.isDragging) {
        // Scroll when dragging close to the edge of the viewport
        var minGap = 30;

        if (progressWidth + minGap > endEdge) {
          this.scrollContainer.scrollLeft += minGap;
        } else if (progressWidth - minGap < startEdge) {
          this.scrollContainer.scrollLeft -= minGap;
        }
      } else {
        if (progressWidth < startEdge || progressWidth > endEdge) {
          this.scrollContainer.scrollLeft = progressWidth - (this.options.autoCenter ? middle : 0);
        } // Keep the cursor centered when playing


        var center = progressWidth - scrollLeft - middle;

        if (isPlaying && this.options.autoCenter && center > 0) {
          this.scrollContainer.scrollLeft += Math.min(center, 10);
        }
      } // Emit the scroll event


      {
        var newScroll = this.scrollContainer.scrollLeft;
        var startX = newScroll / scrollWidth;
        var endX = (newScroll + clientWidth) / scrollWidth;
        this.emit('scroll', startX, endX);
      }
    }
  }, {
    key: "renderProgress",
    value: function renderProgress(progress, isPlaying) {
      if (isNaN(progress)) return;
      var percents = progress * 100;
      this.canvasWrapper.style.clipPath = "polygon(".concat(percents, "% 0, 100% 0, 100% 100%, ").concat(percents, "% 100%)");
      this.progressWrapper.style.width = "".concat(percents, "%");
      this.cursor.style.left = "".concat(percents, "%");
      this.cursor.style.transform = "translateX(-".concat(Math.round(percents) === 100 ? this.options.cursorWidth : 0, "px)");

      if (this.isScrollable && this.options.autoScroll) {
        this.scrollIntoView(progress, isPlaying);
      }
    }
  }, {
    key: "exportImage",
    value: function exportImage(format, quality, type) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var canvases, images;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                canvases = this.canvasWrapper.querySelectorAll('canvas');

                if (canvases.length) {
                  _context5.next = 3;
                  break;
                }

                throw new Error('No waveform data');

              case 3:
                if (!(type === 'dataURL')) {
                  _context5.next = 6;
                  break;
                }

                images = Array.from(canvases).map(function (canvas) {
                  return canvas.toDataURL(format, quality);
                });
                return _context5.abrupt("return", Promise.resolve(images));

              case 6:
                return _context5.abrupt("return", Promise.all(Array.from(canvases).map(function (canvas) {
                  return new Promise(function (resolve, reject) {
                    canvas.toBlob(function (blob) {
                      blob ? resolve(blob) : reject(new Error('Could not export image'));
                    }, format, quality);
                  });
                })));

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }]);

  return Renderer;
}(EventEmitter);

Renderer.MAX_CANVAS_WIDTH = 4000;
export default Renderer;